import React, { FC } from 'react';
import isNil from 'lodash/isNil';

import ProductAuthors from '../ProductAuthors';
import ProductNarrators from '../ProductNarrators';
import { ProductSupplementaries } from '../ProductSupplementaries';
import ProductSeries from '../ProductSeries';
import { ListBadges } from '../../common/BadgesV2';
import { CampaignProvider } from '../../../contexts/campaign';
import { ProductMetaData } from '../../../../models/Product';
import { concreteLoanFormatNameToKey } from '../../loanFormat/mappers';

type Props = {
    readonly product: ProductMetaData;
    readonly isLibx?: boolean;
};

const ProductDetailShortInfo: FC<Props> = ({ product, isLibx }) => {
    const loanFormatKey = concreteLoanFormatNameToKey(product.loanFormat);

    const topRow = isNil(product.seriesName) ? (
        <ProductSupplementaries product={product} types={['Teaser']} isLibx={isLibx} />
    ) : (
        <ProductSeries product={product} className="series" loanFormatKey={loanFormatKey} shopLanguage={undefined} />
    );

    const badges = isLibx ? null : (
        <div className="cw-badges">
            <ListBadges
                product={product}
                loanFormatKey={loanFormatKey}
                showAll={true}
                hideWarningBadges={true}
                shopLanguage={undefined}
            />
        </div>
    );

    return (
        <div className="pd-short-info" data-displayname="ProductDetailShortInfo">
            {topRow}
            <h4>
                {product.title}
                <span className="display-block">{product.subTitle}</span>
            </h4>

            <div className="content-wrap">
                <ProductAuthors
                    product={product}
                    showAsTile={true}
                    loanFormatKey={loanFormatKey}
                    shopLanguage={undefined}
                />
                <ProductNarrators
                    product={product}
                    showAsTile={true}
                    loanFormatKey={loanFormatKey}
                    shopLanguage={undefined}
                />
            </div>

            <CampaignProvider value={{ preventCampaignBadge: true }}>{badges}</CampaignProvider>
        </div>
    );
};

export default ProductDetailShortInfo;
